<template>
	<el-drawer
		title="选择演出(仅能查询已上架小红书且演出未结束的演出)"
		:visible.sync="drawerShow"
		:wrapperClosable="false"
		:destroy-on-close="true"
		size="auto"
		@close="close"
	    >        
        <div class="drawer-content">
			<div>
			   <div class="page-filter-box">				   
				   <el-row :gutter="20">				       
				       <el-col :span="16">
				           <el-input v-model="params.searchValue" class="input-with-select" size="small">
							   <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
								   <el-option label="演出ID" :value="1"></el-option>                               
								   <el-option label="演出名称" :value="2"></el-option>
							   </el-select>
				           </el-input>
				       </el-col>                   
				       <el-col :span="8" class="page-filter-btns">
				           <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
				           <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				       </el-col>
				   </el-row>				   
			   </div>
			   <div class="page-list-box">
			       <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
			           @selection-change="handleSelectionChange">
			           <el-table-column type="selection"></el-table-column>
					   <el-table-column prop="title" label="演出海报">
						   <template slot-scope="scope" >
							   <el-image class="img" :src="scope.row.poster" fit="cover"/>
						   </template>
						</el-table-column>
					   <el-table-column prop="title" label="演出名称" min-width="200" show-overflow-tooltip>
						   <template slot-scope="{row} = scope">
						       {{ row.id }} • {{ row.title }}
						   </template>
					   </el-table-column>						   
			           <el-table-column prop="siteName" label="城市&场地" min-width="130">
			               <template slot-scope="{row} = scope">
			                   {{ row.cityName }} • {{ row.siteName }}
			               </template>
			           </el-table-column>
					   <el-table-column prop="siteName" label="时间" min-width="200">
					       <template slot-scope="scope">
					           <p>开始时间：{{scope.row.beginShowTime}}</p>
					           <p>结束时间：{{scope.row.endShowTime}}</p>
					       </template>
					   </el-table-column>
					   <el-table-column prop="siteName" label="小红书销售" min-width="120">
					       <template slot-scope="scope">
					           <p>销售额：{{scope.row.saleAmount}}</p>
					           <p>销量：{{scope.row.saleNum}}</p>
							   <p>价格：{{scope.row.minPrice}}起</p>
					       </template>
					   </el-table-column>			   			
			       </el-table>
			   </div>
			   <div v-if="data" class="page-pagination-box">
			       <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
			           :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
			           layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			       </el-pagination>
			   </div>
		   </div>
		   
		   
		</div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">添 加</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    
}
export default {
    data() {
       
        return {
            drawerShow: false,
            btnLoading: false,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",                
            },
			update:false,
			reatioDis:false,
			dataList:null,
			data:null,
			listLoading:false,
			activityIds:''
			
        }
    },
    methods: {
        show() {
			this.drawerShow = true
            this.getDataList()
        },
        close() {           
            this.drawerShow = false;
        },
		
		//搜索演出
		getDataList() {
		    this.listLoading = true;
		    this.$request({
		        url: "/redBookletSort/activityList",
		        method: "POST",
		        params: {
		            ...this.params
		        },
		    })
		        .then((res) => {
		            const { state, msg, result } = res.data;
		            if (state == 1 && result) {
		                this.data = result;
		                this.dataList = result.result || [];
		            } else {
		                this.$message.error(msg || "请求失败");
		            }
		        })
		        .catch(() => {
		            this.$message.error("请求错误");
		        })
		        .finally(() => {
		            this.listLoading = false;
		        });
		},
		//选择pageSize
		handleSizeChange(e) {
		    this.params.pageNo = 1;
		    this.params.pageSize = e;
		    this.getDataList();
		},
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.getDataList();
		},
		//重置搜索
		reset() {		    
		    this.params = {
		        ...defaultParams,
		        pageSize: this.params.pageSize
		    };
		    this.getDataList();
		},
		handleSelectionChange(val) {
			this.activityIds = val.map(v => v.id);
		},
		//表单提交
		submitForm() {
			if( this.activityIds == ''){
				return this.$message.error("请先选择演出！");
			}
		    this.btnLoading = true;
		    this.$request({
		        url: "/redBookletSort/add",
		        method: "POST",
		        params: {
		            activityIds:this.activityIds.toString()
		        },
		    })
		        .then((res) => {
		            const { state, msg } = res.data;
		            if (state == 1 ) {
					   this.$emit('onUpdate');
		               this.close()
		            } else {
		                this.$message.error(msg || "请求失败");
		            }
		        })
		        .catch(() => {
		            this.$message.error("请求错误");
		        })
		        .finally(() => {
		            this.btnLoading = false;
		        });
		},
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer .drawer-content .input-with-select{
	display: inline-table;
}
.img{
   max-width: 120px;
   max-height: 120px;
}
</style>